<template>
  <form @submit.prevent="$emit('submit')">
    <div class="-mb-8 -mr-6 flex flex-wrap p-8">
      <text-input
        v-model="form.course.name"
        :errors="form.errors.first_name"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Nume"
      />
      <select-input
        v-model="form.course.type"
        :errors="form.errors.type"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Tip"
      >
        <option :value="'training'">Training</option>
        <option :value="'certification'">Certification</option>
        <option :value="'feedback'">Feedback</option>
      </select-input>
      <file-input
        v-model="form.course.image"
        :errors="form.errors.image"
        class="w-full pb-8 pr-6 lg:w-1/2"
        type="file"
        accept="image/*"
        label="Imagine"
      />
      <span>Imagine curenta: </span>
      <img
        v-if="form.course.existing_image"
        class="ml-4 block max-w-20 max-h-20 w-auto h-auto object-contain"
        :src="form.course.existing_image"
        alt="Photo"
      />
    </div>
    <slot />
  </form>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue';
import SelectInput from '@/Shared/SelectInput.vue';
import FileInput from '@/Shared/FileInput.vue';

export default {
  components: {
    TextInput,
    SelectInput,
    FileInput,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue', 'submit'],
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>
